<template>
  <b-modal v-model="showModal" :title="title" @hide="onModalClose" :hideFooter="hideFooter" :dialogClass="dialogClass">
    <TicketsSoldHistory :id="selectedItemId" :eventName="eventName"/>
  </b-modal>
</template>

<script>
import TicketsSoldHistory from './ticketsSoldHistory.vue';

export default {
  name: 'TicketsSoldHistoryModal',
  components: {
    TicketsSoldHistory
  },
  props: {
    selectedItemId: {
      type: String,
      required: true,
      default: null
    },
    title: {
      type: String,
      default: 'Ticktes Sold'
    },
    hideFooter: {
      type: Boolean,
      default: true
    },
    dialogClass: {
      type: String,
      default: 'modal-xl'
    },
    eventName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      // modalTitle: this.title,
      // selectedItemId: null,
    };
  },
  mounted() {
   this.showModal = true;
  },
  methods: {
    onModalClose() {
      console.log('Modal closed');
      this.showModal = false;
      this.$emit('close');
    }
  }
};
</script>
